import React from "react";
import { useTranslation } from "react-i18next";
import { StatusDisplay } from "../../loads/partials/LoadStatusChip";

function AlpInboundLoadStatus(props: any) {
    const { status, label, textable, chip } = props;
    const { t } = useTranslation();

    if ( status === 'announced' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-primary-500"
                label={ label ? label : t('announced') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'rejected' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('rejected') }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'accepted' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('accepted') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'confirmed' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('confirmed') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'ready-to-be-loaded' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('ready to be loaded') + ' Pending' }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'transport-order-pending' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('pending transport order') }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'transport-order-declined' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('decline transport order') }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'ready-to-load' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('ready to load') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'updated' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-black-500"
                label={ label ? label : t('updated') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'gate-out-confirmation-pending' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-red-500"
                label={ label ? label : t('gate out pending') }
                badgeSeverity="danger"
            />
        );
    }

    if ( status === 'gate-out-confirmation-completed' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('gate out completed') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'in-transit' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-yellow-500"
                label={ label ? label : t('in transit') }
                badgeSeverity="warning"
            />
        );
    }

    if ( status === 'unload-requested' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-black-500"
                label={ label ? label : t('unload requested') }
                badgeSeverity="info"
            />
        );
    }

    if ( status === 'unloaded' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('delivered') }
                badgeSeverity="success"
            />
        );
    }

    if ( status === 'archived' ) {
        return (
            <StatusDisplay
                chip={ chip }
                textable={ textable }
                colorClass="text-green-500"
                label={ label ? label : t('archived') }
                badgeSeverity="success"
            />
        );
    }

    return (
        <span>-</span>
    );
}

export default AlpInboundLoadStatus;
